import { Pagination } from '@library/common/http';

import {
   ReportFilter,
   ReportSchema,
} from '../report';

import { ReportOutput } from './report-output';

export interface ReportRequest {
   filters: ReportFilter[];
   schema: ReportSchema[];
   pagination?: Pagination;
   output: ReportOutput;
   doLineItems: boolean;
}

export class ReportRequest implements ReportRequest {
   constructor( request?: any ) {
      this.filters = request?.filters || [];
      this.schema = request?.schema || [];
      if ( request?.pagination ) { this.pagination = request?.pagination; }
      this.output = new ReportOutput( request?.output );
      this.doLineItems = request?.doLineItems ?? true;
   }
}
